import { render, staticRenderFns } from "./RequestedProductsTable.vue?vue&type=template&id=3e432444&scoped=true"
import script from "./RequestedProductsTable.vue?vue&type=script&lang=js"
export * from "./RequestedProductsTable.vue?vue&type=script&lang=js"
import style0 from "./RequestedProductsTable.vue?vue&type=style&index=0&id=3e432444&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e432444",
  null
  
)

export default component.exports